import * as React from "react";

interface Props extends React.PropsWithChildren {
  name: string | "skip";
}
export const CpLabel: React.FC<Props> = ({ name, children }) => {
  return (
    <label style={{ width: `fit-content` }} htmlFor={name === "skip" ? undefined : name}>
      {children}
    </label>
  );
};
